module.exports = __webpack_public_path__ + "media/images/main_post-be325bf3da5b7480fd49fc98ce6094a8.png";